module.exports = __webpack_public_path__ + "prod/1.2.3/img/couponIcon.0fb53457.svg";